import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import IMG7 from '../assets/IMG8.png';
import IMG8 from '../assets/IMG7.png';
import './Login.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { AuthContext } from '../Context/AuthContext';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { dispatch } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const savedUsername = localStorage.getItem('email');
    if (savedUsername) {
      setUsername(savedUsername);
    }
  }, []);

  const validateForm = () => {
    if (!username.trim()) {
      setError('Username is required');
      return false;
    }
    if (!password) {
      setError('Password is required');
      return false;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return false;
    }
    setError('');
    return true;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setIsSubmitting(true);
    setError('');

    try {
      dispatch({ type: "LOGIN_START" });
      const response = await fetch('https://carrentalbackend.dockyardsoftware.com/api/Auth/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ Username: username, Password: password }),
      });

      const data = await response.json();
      // In the handleLogin function, after successful login:
if (response.ok) {
  localStorage.setItem('token', data.token);
  const decodedToken = JSON.parse(atob(data.token.split('.')[1]));
  
  // Load profile data if it exists
  const userId = decodedToken.userId || decodedToken.id;
  const profileDataKey = `userProfile_${userId}`;
  let profileData = null;
  
  try {
    const storedProfile = localStorage.getItem(profileDataKey);
    if (storedProfile) {
      profileData = JSON.parse(storedProfile);
    }
  } catch (err) {
    console.error("Error loading profile data:", err);
  }

  dispatch({ 
    type: "LOGIN_SUCCESS", 
    payload: {
      user: {
        ...decodedToken,
        ...profileData // Merge profile data
      },
      role: decodedToken.role
    }
  });

        if (decodedToken.role === 'Admin') {
          navigate('/admin/manufacture');
        } else {
          navigate('/userpage');
        }

        if (rememberMe) {
          localStorage.setItem('username', username);
        } else {
          localStorage.removeItem('username');
        }
      } else {
        const errorMessage = data.message || 'Login failed. Please try again.';
        setError(errorMessage);
        dispatch({ 
          type: "LOGIN_FAILURE", 
          payload: errorMessage
        });
      }
    } catch (error) {
      const errorMessage = 'An error occurred. Please try again.';
      setError(errorMessage);
      dispatch({ 
        type: "LOGIN_FAILURE", 
        payload: errorMessage
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="login-container">
      <img src={IMG7} alt="Background" className="background-img" />
      <img src={IMG8} alt="Overlay" className="overlay-img" />

      <p className="welcome-text1">Welcome Back!</p>
      <p className="welcome-text2">Log in To Unlock Your Ride And</p>
      <p className="welcome-text3">Hit The Road!</p>

      <div className="login-content-adjusted">
        <h2 className="login-heading">Login</h2>
        <p className="welcome-text">Welcome back! Please log in to your account.</p>
        <div className="login-form-container">
          <form onSubmit={handleLogin}>
            <div>
              <label>Username:</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </div>

            <div className="input-group">
              <label className="input-label">
                Password:
                <div className="password-field-inside-label">
                  <input
                    type={showPassword ? 'text' : 'password'}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className="password-toggle-icon"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </span>
                </div>
              </label>
            </div>

            {/* <div className="remember-me">
              <input
                type="checkbox"
                id="rememberMe"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="rememberMe">Remember me</label>
            </div> */}

            {error && <div className="error-message">{error}</div>}

            <button 
              type="submit" 
              className="login-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Logging in...' : 'Login'}
            </button>
          </form>
          <p className="end-text">
            New User? <a href="/signin">Sign Up</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;